module.exports = __webpack_public_path__ + "img/w15.293276c5.svg";